import Swal from "sweetalert2";
import showAlert from "../server/ShowAlert";

// Max orderable quantity, rounded down to a whole weightJump. Infinity when stock unknown
// or when the product may be ordered while out of stock.
export function getMaxStockQty(
  availableQuantity,
  weightJump,
  allowOrderWhenOos,
) {
  if (allowOrderWhenOos) return Infinity;
  if (availableQuantity == null) return Infinity;
  const jump = weightJump > 0 ? weightJump : 1;
  return Math.floor(availableQuantity / jump) * jump;
}

// Single source for the stock message — same wording the reducer used inline.
export function stockLimitMessage(quantity) {
  if (quantity <= 0) return "המוצר לא במלאי";
  if (quantity === 1) return "מצטערים, יש במלאי יחידה אחת";
  return `מצטערים, יש במלאי ${quantity} יחידות`;
}

// Immediate notice that the quantity was capped by stock.
// Throttle: SweetAlert2 shows one popup at a time, so skip re-firing while one is
// open — avoids resetting the timer / flicker on rapid clicks.
export function notifyStockLimit(maxQty) {
  if (Swal.isVisible()) return;
  // Don't let rapid clicks on the backdrop dismiss it — let the 3s timer close it.
  showAlert({
    msgTitle: stockLimitMessage(maxQty),
    msgTimer: 3000,
    allowOutsideClick: false,
  });
}
